import React from 'react';
import { MdCheckCircle } from 'react-icons/md';
import {
    ADMIN,
    ASSISTANT_MANAGER,
    MANAGER
} from 'components/RoleGate/constants';
import RoleButton from 'components/RoleButton';
import ButtonIconWrapper from 'components/ButtonIconWrapper';

import FertilizerEventHasIncompleteEventsGate from '../FertilizerEventHasIncompleteEventsGate';
import { FERTILIZER_EVENTS_COMPLETE_MODAL } from '../../../../constants';

export default function FertilizerEventCompleteButton(): React.ReactElement {
    return (
        <FertilizerEventHasIncompleteEventsGate>
            <RoleButton
                requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
                params={{
                    [FERTILIZER_EVENTS_COMPLETE_MODAL]: true
                }}
                buttonProps={{
                    icon: true,
                    color: 'black',
                    basic: true,
                    style: {
                        marginRight: 0,
                        marginLeft: 8
                    }
                }}
                ignoreSeason
            >
                <ButtonIconWrapper>
                    <MdCheckCircle
                        style={{
                            fontSize: 20
                        }}
                    />
                </ButtonIconWrapper>
                Complete
            </RoleButton>
        </FertilizerEventHasIncompleteEventsGate>
    );
}
